import { IconHiFive } from "@/components/design-system/icons/IconHiFive";
import { IconSpeedometer } from "@/components/design-system/icons/IconSpeedometer";
import { IconAnalytics } from "@/components/design-system/icons/IconAnalytics";
import { type BenefitItem } from "@/components/design-system/BenefitCard/BenefitCard";

export const benefits: readonly BenefitItem[] = [
  {
    Icon: IconHiFive,
    title: "Reduce stress-driven turnover",
    description:
      "40% of voluntary turnover is financially driven. Bravo addresses root causes before employees start job searching — keeping your best people where they belong.",
  },
  {
    Icon: IconSpeedometer,
    title: "Recover lost productivity",
    description:
      "Financially stressed employees lose 3+ hours a week dealing with personal finance during work hours. Bravo reduces that friction, converting worry into action.",
  },
  {
    Icon: IconAnalytics,
    title: "Maximise benefit ROI",
    description:
      "Most employees leave significant benefit value unclaimed every year. Bravo ensures your investment in benefits actually reaches employees — and they understand it.",
  },
];
